
import {classList} from '../index';
import {STORE_URL} from '@util/URLUtils';

const DEFAULT_MESSAGE = 'Sorry, We were unable to retrieve your cart information.';
const Error = ( {message = DEFAULT_MESSAGE}, context ) => (
    <div data-testid="cart-error" className={classList.cartEmpty}>
        <p className="mb-4">{message}</p>
        <a className="button secondary text-base" href={STORE_URL}>
            Go to Your Cart
        </a>
    </div>
);

export default Error;